<div class="page-content-inner mat-typography" fxLayout="column">
  <gz-fuel-resource-list fxFlex
                         resourceType="worlds"
                         [resources]="worlds"
                         [length]="paginatedWorlds.totalCount"
                         [finished]="!paginatedWorlds.hasNextPage()"
                         (pageChange)="getWorlds($event)">
  </gz-fuel-resource-list>
</div>
